module.exports = __webpack_public_path__ + "img/college7.b0f8bdf5.png";